export default __webpack_public_path__ + "images/DisplayBilder.webp?4e5faeab5e915bb755647b37f49c22df";